import React, {FunctionComponent} from 'react';
import {FormattedMessage} from 'react-intl';

import styles from './static-text-screen.module.css';

interface Props {
  headlineId?: string;
}

const StaticTextScreen: FunctionComponent<Props> = props => {
  const {headlineId, children} = props;

  return (
    <div className={styles.container}>
      {headlineId && (
        <h1>
          <FormattedMessage id={headlineId} />
        </h1>
      )}

      {children}
    </div>
  );
};

export default StaticTextScreen;
